// extracted by mini-css-extract-plugin
export default {"wrap":"langButtons_wrap__XezzF","end":"langButtons_end__HN238"};